import { ComponentPropsWithoutRef } from "react";
import styles from "./styles.module.scss";
import { TextTags } from "./types";
import { twCn } from "@/styles/utils";

type Props<T extends TextTags> = ComponentPropsWithoutRef<T> & {
  as?: T;
  type?:
    | "default"
    | "bodyBold"
    | "bodySmall"
    | "value"
    | "label"
    | "caption"
    | "title"
    | "titleMobile"
    | "h1"
    | "h3";
  weight?: "regular" | "semiBold" | "bold";
  color?: string;
  align?: "left" | "center" | "right";
  lineHeight?: number;
  ellipsis?: boolean;
};

export const Typography = <T extends TextTags = "span">({
  as,
  type = "default",
  weight,
  color,
  align = "left",
  lineHeight,
  ellipsis,
  className,
  ...props
}: Props<T>) => {
  const Tag = as ?? "span";
  return (
    <Tag
      {...props}
      style={{
        color,
        textAlign: align,
        lineHeight: lineHeight ? `${lineHeight}px` : undefined,
      }}
      className={
        twCn(
          "text-inherit",
          className,
          styles[type],
          weight && styles[weight],
          ellipsis && "truncate",
        ) || undefined
      }
    />
  );
};
